import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { useContext, useEffect, useState } from 'react'
import { ShowRowItemQuery } from './__generated__/show_query'
import { Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Subheading } from '@/components/base/heading'
import { BanknotesIcon } from '@heroicons/react/24/solid'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { formatCurrency } from '@/helpers/formatCurrency'
import { Text } from '@/components/base/text'
import { Button } from '../base/button'
import { EditDialog } from './edit_dialog'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'

type RowItem = ShowRowItemQuery['rowItems']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [rowItem, setRowItem] = useState<RowItem | null>(null)
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const { data, loading, error } = useQuery<ShowRowItemQuery>(Query, { variables: { filters: { idEq: id } } })
  const { currentCompany } = useContext(CurrentTenantContext)

  useEffect(() => {
    if (!data || !id) { return }

    setRowItem(data.rowItems.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  const onDelete = () => {
    setOpenDelete(true)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={setOpen}>
        <DialogTitle>
          {
            loading || !rowItem
              ? <Loading />
              : <div className="flex flex-row justify-between">
                <div>
                  <span className="flex flex-row gap-4 items-center pb-6">
                    { rowItem.name }
                  </span>
                  <span className="flex flex-row gap-2 items-center">
                    <BanknotesIcon className="h-6 w-6" />
                    <Subheading>Cost</Subheading>
                    <Text>{ formatCurrency(currentCompany?.currency || 'GBP', rowItem.priceCents) }</Text>
                  </span>
                </div>
              </div>
          }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
        </DialogBody>
        <DialogActions>
          { rowItem && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { rowItem && <Button color="red" onClick={onDelete}>Delete</Button> }

        </DialogActions>
      </Dialog>
      { rowItem && <EditDialog id={rowItem.id} open={openEdit} setOpen={setOpenEdit} /> }
      { rowItem && <DeleteDialog
        id={rowItem.id}
        mutation={DeleteMutation}
        open={openDelete}
        refetchQueries={[TableQuery]}
        setOpen={setOpenDelete}
        onSuccess={onDeleteSuccess}
      /> }
    </>
  )
}
